import { render, staticRenderFns } from "./ManualCategory.vue?vue&type=template&id=04c94635"
import script from "./ManualCategory.vue?vue&type=script&lang=js"
export * from "./ManualCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports